import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BadgeProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-badge',
  template: '<div></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: { class: 'flex overflow-hidden' },
  imports: [CommonModule],
})
export class BlFrontendBadgeComponent extends BlFrontendBaseComponent<BadgeProps> {
  @Input() text: BadgeProps['text'];
  @Input() variant?: BadgeProps['variant'] = 'neutral';
  @Input() trailingIcon?: BadgeProps['trailingIcon'];
  @Input() leadingIcon?: BadgeProps['leadingIcon'];
  @Input() emphasis?: BadgeProps['emphasis'] = 'subtle';

  protected override getComponentName(): string {
    return 'Badge';
  }

  protected override getProps(): BadgeProps {
    return {
      text: this.text,
      variant: this.variant,
      trailingIcon: this.trailingIcon,
      leadingIcon: this.leadingIcon,
      emphasis: this.emphasis,
    };
  }
}
